import ChartNavBar from 'shared-assets/facesheet-ui/components/ChartNavBar/ChartNavBar';

angular
  .module('kareo.ui.shared.directives.chart-navbar', [
    'react'
  ])
  .directive('chartNavBar', chartNavBar);

chartNavBar.$inject = ['reactDirective'];
function chartNavBar(reactDirective) {
  var bindings = {
    patientId: '=',
    displayWidget: '=',
  };

  return reactDirective(ChartNavBar, bindings, props => {
    props.patientId = parseInt(props.patientId);
    props.displayWidget = props.displayWidget;
    return props;
  });
}